module.exports = __webpack_public_path__ + "img/speaker-l.da4456af.png";